module.exports = __webpack_public_path__ + "img/donate-amount.d961a8c3.svg";